/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParameterTypes } from './ParameterTypes';
import {
    ParameterTypesFromJSON,
    ParameterTypesFromJSONTyped,
    ParameterTypesToJSON,
    ParameterTypesToJSONTyped,
} from './ParameterTypes';

/**
 * 
 * @export
 * @interface ConfigurableParameterDto
 */
export interface ConfigurableParameterDto {
    /**
     * 
     * @type {ParameterTypes}
     * @memberof ConfigurableParameterDto
     */
    type: ParameterTypes;
    /**
     * 
     * @type {Array<number>}
     * @memberof ConfigurableParameterDto
     */
    values?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof ConfigurableParameterDto
     */
    unit?: string;
    /**
     * 
     * @type {ConfigurableParameterDto}
     * @memberof ConfigurableParameterDto
     */
    parameter?: ConfigurableParameterDto;
}



/**
 * Check if a given object implements the ConfigurableParameterDto interface.
 */
export function instanceOfConfigurableParameterDto(value: object): value is ConfigurableParameterDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function ConfigurableParameterDtoFromJSON(json: any): ConfigurableParameterDto {
    return ConfigurableParameterDtoFromJSONTyped(json, false);
}

export function ConfigurableParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurableParameterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': ParameterTypesFromJSON(json['type']),
        'values': json['values'] == null ? undefined : json['values'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'parameter': json['parameter'] == null ? undefined : ConfigurableParameterDtoFromJSON(json['parameter']),
    };
}

export function ConfigurableParameterDtoToJSON(json: any): ConfigurableParameterDto {
    return ConfigurableParameterDtoToJSONTyped(json, false);
}

export function ConfigurableParameterDtoToJSONTyped(value?: ConfigurableParameterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': ParameterTypesToJSON(value['type']),
        'values': value['values'],
        'unit': value['unit'],
        'parameter': ConfigurableParameterDtoToJSON(value['parameter']),
    };
}

